export default __webpack_public_path__ + "static/media/uil_history.1ff2b20b.svg";